<div class="password-field">
  <div *ngIf="label" class="password-label-row">
    <label [attr.for]="inputId || null">{{ labelText }}</label>
    <app-info-icon *ngIf="infoMessage" [message]="infoMessage" class="password-info-icon"></app-info-icon>
  </div>

  <div class="password-input-wrapper">
    <input
      [id]="inputId || null"
      [type]="inputType"
      [name]="name || null"
      [formControl]="control"
      [placeholder]="placeholder || ''"
      [autocomplete]="autocomplete || 'off'"
      [attr.maxlength]="maxLength"
      class="form-control"
      [ngClass]="inputClass"
      (keypress)="keypressEvent.emit($event)"
      (keydown)="keydownEvent.emit($event)"
      (blur)="blurEvent.emit($event)"
      (focus)="focusEvent.emit($event)"
      (paste)="pasteEvent.emit($event)"
    />

    <button
      type="button"
      class="password-toggle-btn"
      (click)="togglePasswordVisibility()"
      [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"
    >
      <em [ngClass]="isPasswordVisible ? 'icon-litepassword-eye-open' : 'icon-litepassword-eye-closed'"></em>
    </button>
  </div>
</div>
